import React, {useEffect, useRef} from "react";
import PropTypes from "prop-types";
import {Dialog} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(() => ({
    smallerZIndex: {
        zIndex: "1299 !important"
    }
}));

const NoIndexDialog = ({
    children,
    smallerZIndex,
    ...props
}) => {
    const myRef = useRef(null);
    const classes = useStyles();

    const removeTabIndex = () => {
        myRef?.current?.getElementsByClassName("MuiDialog-container")[0].removeAttribute("tabindex");
    };

    useEffect(() => {
        setTimeout(removeTabIndex, 1000);
    }, []);

    return (
        <Dialog
            className={smallerZIndex ? classes.smallerZIndex : ""}
            ref={myRef}
            {...props}
        >
            {children}
        </Dialog>
    );
};

NoIndexDialog.defaultProps = {
    smallerZIndex: false
};

NoIndexDialog.propTypes = {
    children: PropTypes.any,
    smallerZIndex: PropTypes.bool
};

export default NoIndexDialog;
